import React, { ReactNode } from 'react';
import parse from 'html-react-parser';
import { Container } from './styles';
import { subjectTypes } from '../../@types/entities/subjects.entity';

interface Props {
  children: string | ReactNode;
  subject: subjectTypes | string;
}

export default function Highlight({ children, subject }: Props) {
  return (
    <Container $color={30} $subject={subject}>
      <div className="highlight-content">
        {typeof children === 'string' ? parse(children) : children}
      </div>
    </Container>
  );
}
